import {Payload} from './payload';
import {SummaryPayload} from './summary.payload';

export class PayloadWithSummary implements Payload {
    summary: SummaryPayload;
}
